import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const partners = [
  {
    name: "DP World",
    logo: "assets/images/dpworld.png",
  },
  {
    name: "Delhivery",
    logo: "assets/images/delhiveryLogo.png",
  },
  {
    name: "Ecom Express",
    logo: "assets/images/exomLogo.png",
  },
  {
    name: "Blue Dart / DHL",
    logo: "assets/images/bluedart.png",
  },
  {
    name: "Safexpress",
    logo: "assets/images/safexpress.png",
  },
  {
    name: "Movein Logistics",
    logo: "assets/images/moveinLogo.png",
  },
  {
    name: "Amazon Shipping",
    logo: "assets/images/amzonLogo.png",
  },
  {
    name: "Allcargo Logistics",
    logo: "assets/images/Allcargo-Gati.jpg",
  },
];

export default function PartnerCarousel() {
  return (
    <section className="pt-6 pb-10 bg-gradient-to-b from-slate-50 to-white overflow-hidden">
      
      {/* Heading */}
      <h2 className="text-center text-3xl md:text-6xl font-bold mb-6">
        <span className="bg-gradient-to-r from-blue-700 to-cyan-500 bg-clip-text text-transparent">
          Our Partners
        </span>
      </h2>

      <div className="w-full mx-auto px-4 md:px-10">
        <Swiper
          modules={[Autoplay]}
          spaceBetween={20}
          loop={true}
          speed={3000} // smoother flow
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          allowTouchMove={true}
          grabCursor={true}
          breakpoints={{
            320: { slidesPerView: 2 },
            640: { slidesPerView: 3 },
            768: { slidesPerView: 4 },
            1024: { slidesPerView: 5 },
          }}
        >
          {[...partners, ...partners].map((partner, index) => (
            <SwiperSlide key={index}>
              
              <div className="group h-24 md:h-28 w-full flex items-center justify-center rounded-2xl bg-white border border-gray-200 shadow-md hover:shadow-xl transition duration-300">

                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="h-[90%] w-[90%] object-contain p-4  transition duration-300"
                />

              </div>

            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}